// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const LinkPage = (props) => {
  useRetractSidebar()

  return (
    <div id="link-page">
      <EntityEditForm
        entities="links"
        id={props.match.params.id}
        fields={[{ name: 'name' }, { name: 'category' }, { name: 'url' }, { name: 'company' }]}
        resource="Links"
      />
    </div>
  )
}

export default LinkPage
